import "angular";
import "angular-ui-router";
import VersionsViewController from "./VersionsViewController";
import VersionsViewRouteStates from "./VersionsViewRouteStates";

var VersionsModule = angular.module("VersionsModule", [
    // Libraries
    "ngResource",
    "ui.router"
]);
// Controllers
VersionsModule.controller("VersionsViewController", VersionsViewController);
VersionsModule.config(VersionsViewRouteStates);

export default VersionsModule;
